<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.edit')" position="top">
                <feather-icon icon="EditIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top" v-if="isPermissionDelete()">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>
    </div>
</template>

<script>

import { isAPI } from '../../../../store/permission';
import { constAPI } from '../../../../store/constant';
export default {
    name: 'OrganizationBranchCellRendererActions',
    methods: {
        isPermissionDelete() {
            return isAPI(this, constAPI.work_shift_branch_delete)
        },
        editRecord() {
            this.$router.push(`/user/edit-work-shift?branch_id=${this.params.data.organizationBranchId}&id=${this.params.data.id}`).catch(() => {
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá ca "${this.params.data.name}" nhóm "${this.params.data.groupName}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post('/work-shift/organization/delete/' + this.params.data.id).then(() => {
                this.showDeleteSuccess()
                this.$vs.loading.close();
                this.$store.commit('UPDATE_ORGANIZATION_WORK_SHIFT', true);
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    }
}
</script>
<style scoped>

</style>
